import React, { useState } from "react";
import SessionTracker from "./sessionTracker";
import "./novel-object-video-counter.css";
import NovelObjectVideoStats from "./novel-object-video-stats.jsx";
import mouse from "./cartoon-mouse.svg";

function NovelObjectVideoCounter() {
  const [sessionTracker, setTracker] = useState(null);
  const [duration, setDuration] = useState(0);
  const [mousePosition, setMousePosition] = useState("exploring");
  const [sessionStatus, setSessionStatus] = useState({
    sessionStarted: false,
    sessionEnded: false,
  });

  function validateDuration(e) {
    if (
      (e.target.value >= 0 && e.target.value <= 21600) ||
      e.target.value === null
    )
      setDuration(parseInt(e.target.value));
  }

  function GetArrowKeyHandler(tracker) {
    return (e) => {
      if (e.key === "ArrowLeft") tracker.HandleLeftEvent();
      else if (e.key === "ArrowRight") tracker.HandleRightEvent();
    };
  }

  let arrowKeyHandler = null;

  function startSession() {
    if (!duration) return;

    setSessionStatus({ sessionStarted: true, sessionEnded: false });
    let tracker = new SessionTracker(
      "phase",
      duration,
      null,
      endSession
    );
    arrowKeyHandler = GetArrowKeyHandler(tracker);
    window.addEventListener("keyup", arrowKeyHandler);

    setTracker(tracker);
    tracker.SetMousePositionUpdateCallback(setMousePosition);
    tracker.StartRecording();
  }

  function endSession() {
    setSessionStatus({ sessionStarted: false, sessionEnded: true });
    window.removeEventListener("keyup", arrowKeyHandler);
    setTracker(null);
  }

  return (
    <div className="video-counter">
      <div>
        <label htmlFor="duration">
          Video Duration:
          <input
            type="number"
            id="duration"
            name="duration"
            value={duration || ""}
            onChange={validateDuration}
            onKeyDown={(e) =>
              (e.key === "e" || e.key === ".") && e.preventDefault()
            }
          />
          seconds
        </label>
        {!sessionStatus.sessionStarted || sessionStatus.sessionEnded ? (
          <button onClick={startSession}>Start</button>
        ) : (
          <button
            onClick={() => {
              sessionTracker.EndSession();
            }}
          >
            Cancel
          </button>
        )}
      </div>
      <div id="mouse-location-visualiser" >
        <img src={mouse} className={mousePosition} alt="A cartoon mouse." />
      </div>
      <div id="move-mouse-buttons">
        <button
          onClick={() => {
            if (sessionTracker) sessionTracker.HandleLeftEvent();
          }}
          disabled={sessionStatus.sessionEnded || !sessionStatus.sessionStarted}
        >
          Left
        </button>
        <button
          onClick={() => {
            if (sessionTracker) sessionTracker.HandleRightEvent();
          }}
          disabled={sessionStatus.sessionEnded || !sessionStatus.sessionStarted}
        >
          Right
        </button>
      </div>
      <NovelObjectVideoStats props={sessionTracker} />
    </div>
  );
}

export default NovelObjectVideoCounter;
